// @flow

import { useState, useCallback } from 'react'

export const useModalController = (defaultValue: boolean = false) => {
  const [isOpen, setOpen] = useState(defaultValue)
  const [meta, setMeta] = useState(null)

  const toggle = useCallback(() => setOpen((prevValue) => !prevValue), [])

  const show = useCallback((metaData: Object) => {
    setOpen(true)

    if (metaData) {
      setMeta(metaData)
    }
  }, [])

  const hide = useCallback(() => {
    setOpen(false)
    setTimeout(() => setMeta(null), 100)
  }, [])

  return {
    isOpen,
    meta,
    toggle,
    show,
    hide,
  }
}

export default useModalController
